import { render } from "./DynamicTable.vue?vue&type=template&id=2fd853c6&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"

import "./DynamicTable.vue?vue&type=style&index=0&id=2fd853c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd853c6"]])

export default __exports__